<h5><i class="fas fa-file-search"></i> Consulta de Impedimentos</h5>

<div class="container">
  <form [formGroup]="pesquisaForm" class="mt-3 mx-auto" (keyup.enter)="focusableSubmit.click()">
    <div class="row align-items-center">
      <div class="col"><h3>Filtros de pesquisa</h3></div>
      <div class="col-auto">
        <button type="button" class="btn btn-outline-secondary" (click)="limpar()">Limpar</button>
      </div>
      <div class="col-auto">
        <button #focusableSubmit type="button" class="btn btn-success"
                (keydown.enter)="buscar(false, true)" (click)="buscar(false, true)">Pesquisar</button>
      </div>
    </div>

    <div class="row">
      <!-- CNPJ Beneficiario: busca pela RAIZ do documento -->
      <div class="bn-form-group col-md-4">
        <label class="form-label" for="cnpj">
          CNPJ Beneficiário
          <i class="fas fa-question-circle text-muted"
             ngbTooltip="O número do CNPJ beneficiário (apenas números - sem pontos/traços). No caso do CNPJ, a consulta é realizada pela raiz do documento.">
          </i>
        </label>
        <input id="cnpj" type="text" class="form-control" formControlName="cnpj" />
      </div>

      <!-- Dropdown Impedimentos -->
      <div class="bn-form-group col-md-4">
        <label class="form-label" for="impedimento">Impedimentos</label>
        <select id="impedimento" class="form-select" formControlName="impedimento">
          <option *ngFor="let op of opcoesImpedimento" [value]="op.valor">{{ op.label }}</option>
        </select>
      </div>
    </div>
  </form>
</div>

<bn-loading-overlay></bn-loading-overlay>

<div class="container" *ngIf="pesquisado && atualizadoEm">
  <small class="text-muted">atualizado em: {{ atualizadoEm | date: 'dd/MM/yyyy HH:mm:ss' }}</small>
</div>

<app-consulta-cadin-listar *ngIf="pesquisado" [hidden]="esconderPesquisa"
                           [consultas]="consultas"
                           [atributosPaginacao]="atributosPaginacaoComponenteListagem"
                           (aoMudarPagina)="mudancaPagina($event)">
</app-consulta-cadin-listar>
